/* 
 * This does a similar thing to what you'll find in lib.js
 *
 * Why have both? 
 *
 * lib.js was created for external sites, and the widget it currently supports 
 * expects the external widget css to be loaded, which we don't want to use for 
 * widgets on our site.  It has a reset and everything is !important - it doesn't
 * match the style of the rwgps site.
 *
 * It also uses a stubbed rwgps ready function that is pretty much the same as what 
 * you'll find in rwgps.js (lets you do rwgps(function() { }) which will execute once 
 * the rwgps reqs are loaded) but it maintains its own list of functions to run, etc.
 * Not interested in having both in place.
 *
 * So for now... going to build compatible widgets in here which will load their own deps
 * and whatnot, and once we have a widget that needs to be both internally and 
 * externally used, we can reconcile this with lib.js
 *
 * Also, lib.js uses tunnel.html and easyXDM for rwgps.api.  This file supplies a 
 * stubbed version that doesn't need to jump through those hoops (more shit to reconcile)
 */
(function(rwgps) {
  // first let's define the on-site version of rwgps.api, contrast with what's in lib.js
  // interface is the same though, so callers dont have to be changed once its reconciled
  rwgps.api = function(endpoint, method, params, callback) {
    /** clean up endpoint **/
    if(/^\//.test(endpoint)) {
      // remove leading slash
      endpoint = endpoint.slice(1);
    }
    if(!/\.json/.test(endpoint)) {
      // append .json 
      endpoint += '.json';
    }
    // tunnel.html does endpoint validation but we trust ourselves so not going to bother
    if(!/^get|post|put|delete$/i.test(method)) {
      callback = params;
      params = method;
      method = 'get';
    }
    if(typeof params === 'function') {
      callback = params;
      params = {};
    }
    var options = {
      url: '/' + endpoint,
      data: params,
      type: method
    };
    options.complete = function(xhr) {
      if (xhr.status !== 200) {
        throw {name: 'BadResponseError'}
      } else {
        callback(JSON.parse(xhr.responseText));
      }
    };
    jQuery.ajax(options);
  }
  // loadScript and loadStylesheet are just copied from sdk.js FYI 
  rwgps.loadScript = function(url, callback) {
    var script = document.createElement('script');
    script.async = true;
    script.src = url;
    var entry = document.getElementsByTagName('script')[0];
    entry.parentNode.insertBefore(script, entry);
    script.onload = script.onreadystatechange = function() {
      var readyState = script.readyState;
      if(!readyState || /complete|loaded/.test(script.readyState)) {
        callback();
        script.onload = null;
        script.onreadystatechange = null;
      }
    };
  };
  rwgps.loadStylesheet = function(href, cb) {
    var link = document.createElement("link"),
        onload = function() {
          if ( ! done ) {
            done = 1;
            link.removeAttribute("id");
            setTimeout( cb, 0 );
          }
        },
        id = "rwgps" + (+new Date()),
        ref, done;
    cb = cb || function(){};

    link.href = href;
    link.rel  = "stylesheet";
    link.type = "text/css";
    link.id = id;

    ref = document.getElementsByTagName('script')[0];
    ref.parentNode.insertBefore(link, ref);
    link.onload = onload;

    function poll() {
      try {
        var sheets = document.styleSheets;
        for(var j=0, k=sheets.length; j<k; j++) {
          if(sheets[j].ownerNode.id == id) {
            // this throws an exception, I believe, if not full loaded (was originally just "sheets[j].cssRules;")
            if (sheets[j].cssRules.length)
              return onload();
          }
        }
        // if we get here, its not in document.styleSheets (we never saw the ID)
        throw new Error;
      } catch(e) {
        // Keep polling
        setTimeout(poll, 20);
      }
    }
    poll();
  };

  // alright we're done stubbing stuff and copy-pasting things onto the real code

  // make new widgets by assigning new instance to prototype, see examples below
  rwgps.widget = function() {
    this.initialize.apply(this, arguments);
    this._afterLoaded = [];
  }
  rwgps.widget.prototype = {
    // optionally override 
    initialize: function() {},
    deps: [], // override this to be an array of dependencies (will be loaded in parallel)
    // implement this, it will get called by render after deps are loaded
    renderSync: function() {
      throw "renderSync not implemented";
    },
    loaded: function(fn) {
      if(this._loaded) fn();
      else this._afterLoaded.push(fn);
      this.load();
    },
    load: function() {
      if(this._loading) return;
      this._loading = true;
      var that = this;
      async.forEach(this.deps, function(dep, cb) {
        if(/\.js$/.test(dep)) {
          rwgps.loadScript(dep, cb);
        } else if(/\.css$/.test(dep)) {
          rwgps.loadStylesheet(dep, cb);
        } else {
          cb("Unrecognized file type " + dep);
        }
      }, function() {
        that.loadComplete();
      });
    },
    loadComplete: function() {
      while(this._afterLoaded.length) 
        (this._afterLoaded.pop())();
      this._loaded = true;
    },
    render: function() {
      var that = this;
      this.loaded(function() {
        that.renderSync.apply(that, arguments);
      });
    }
  };
  // specialized version of backbone's implementation for Model/Collection/etc.extend
  rwgps.widget.extend = function(protoProps) {
    var parent = this;
    var child = function(){ return parent.apply(this, arguments); }
    var Surrogate = function(){ this.constructor = child; };
    Surrogate.prototype = parent.prototype;
    child.prototype = new Surrogate;
    _.extend(child.prototype, protoProps);
    return child;
  };

  rwgps.widget.RouteSelector = rwgps.widget.extend({
    initialize: function($el) {
      this.target = $el;
      this.sortField = 'createdAt';
      this.sortDir = -1;
    },
    deps: [
      '/javascripts/strftime.min.js',
      '/javascripts/select2.min.js',
      '/stylesheets/select2.min.css'
    ],
    formatOption: function(option) {
      var data = $(option.element).data();
      if(data.distance && data.createdAt) {
        return option.text + 
          "<div style='float:right;font-style:italic;'>" + 
          rwgps.LabelMaker.longLabel(data.distance, true) +
          " - " + 
          rwgps.DateExt.parse(data.createdAt).strftime("%Y-%m-%d") + 
          "</div><div style='clear:right'></div>";
      } else { 
        return option.text;
      }
    },
    renderSync: function() {
      var $el = this.target;
      var widget = this;
      $el.select2({
        matcher: function(term, text) {
          return text.toLowerCase().score(term.toLowerCase());
        },
        sortResults: function(results, container, query) {
          if(query.term != '') {
            container.parent().find('.route-selector-sorter').hide();
            return _.sortBy(results, function(result) {
              return -result.text.toLowerCase().score(query.term.toLowerCase());
            });
          } else {
            container.parent().find('.route-selector-sorter').show();
            var sortField = widget.sortField;
            var sorted = _.sortBy(results, function(result) {
              if(sortField === 'createdAt') {
                return widget.sortDir * rwgps.DateExt.parse($(result.element).data(sortField)).getTime();
              } else if(sortField === 'name') { 
                return result.text;
              } else {
                return widget.sortDir * $(result.element).data(widget.sortField);
              }
            });
            if(sortField === 'name' && widget.sortDir === -1) {
              sorted.reverse();
            }
            return sorted;
          }
        },
        width:'400px',
        placeholder: $el.attr('data-rwgps-widget-placeholder'),
        allowClear: true,
        formatResult: this.formatOption
      });
      $el.select2('container').data('widget', widget);
      // render sorting options
      $el.on('open', function() { 
        var that = this;
        $('.select2-with-searchbox').each(function() {
          var $container = $(this);
          if($container.find('.route-selector-sorter').size() === 0) {
            var $sorter = $('<div class="route-selector-sorter" style="margin-top:4px;float:right;">' +
              T.t('sort_by') +
              ': <a href="javascript:;" class="route-selector-sort-by" data-sort-by="name">' +
              T.t('name') +
              '</a>, <a href="javascript:;" class="route-selector-sort-by" data-sort-by="distance">' +
              T.t('distance') +
              '</a>, <a href="javascript:;" class="route-selector-sort-by" data-sort-by="createdAt" style="font-weight:bold">' +
              T.t('date') +
              '</a></div>');
            $container.find('.select2-search').append($sorter);
            $(that).select2('positionDropdown');
            $sorter.on('click', '.route-selector-sort-by', function() {
              var widget = $('.select2-container-active').data('widget');
              $(this).siblings('.route-selector-sort-by').css({fontWeight: 'normal'});
              $(this).css({fontWeight: 'bold'});
              var oldDir = $(this).data('sort-dir');
              widget.sortField = $(this).data('sort-by');
              widget.sortDir = oldDir == 1 ? -1 : 1;
              $(this).data('sort-dir', widget.sortDir);
              // this requires adding updateResults to the allowedMethods in select2.js
              $('.select2-container-active').select2('updateResults');
            });
          }
        });
      });
    }
  });

  // $el is optional - search whole page for widgets, or search $el
  rwgps.widget.findAndRender = function($el) {
    $(function() {
      var $col = $el ? $el.find('.rwgps-widget') : $('.rwgps-widget');
      $col.each(function() {
        var $this = $(this),
            type = $this.attr('data-rwgps-widget-type');
        // prevent it from getting rendered again
        $this.removeClass('rwgps-widget');
        switch(type) {
          case 'route-selector':
            var rs = new rwgps.widget.RouteSelector($this);
            rs.render();
            break;
        }
      });
    });
  };

  // initialize any widgets on the page
  rwgps.widget.findAndRender();
})(rwgps);



// WEBPACK FOOTER //
// ./public/javascripts/on_site_widgets.js